import { ALL_GROUP_OPTION_LISTS, CLEAR_SEARCH_TEXT, CLEAR_SORT_FILTERS_OF_GROUP, DECREMENT_CART_QUANTITY, DISABLE_CATALOGUE_DRAWER, ENABLE_CATALOGUE_DRAWER, GROUP_PARTY_DATA, GROUP_PARTY_FILTER_HEADING, GROUP_PARTY_LOADING, HANDLE_DATE_FILTERS, HANDLE_FILTERS_IS_CHECKED, HANDLE_SELECT_ALL_FILTERS, INCREMENT_CART_QUANTITY, INCREMENT_PAGES, PARTY_FILTER_STATE, REMOVE_CART, SCROLL_POSITION_FINDER, SEARCH_ITEM_DATA, SET_ACTIVE_CATALOGUE_ID, SET_ADD_CART, SET_ALL_ITEMS, SET_CATALOGUE_DATA, SET_CATALOGUE_STATUS, SET_CLIENT_NAME, SET_CUSTOM_CATALOGUE, SET_DRAWER, SET_ERROR_MESSAGE, SET_FILTER_DATA, SET_FILTER_TAB_OPTION, SET_GUID, SET_HAS_MORE, SET_HEADER_DOCUMENT_LIST, SET_ITEMS_DATA, SET_ITEM_EDIT_IS_SELECTED, SET_ITEM_EDIT_NOT_SELECTED, SET_ITEM_IS_NOT_SELECTED, SET_ITEM_IS_SELECTED, SET_ITEM_PK_ID, SET_LOADING, SET_LOGIN, SET_LOGOUT, SET_MOBILE_NUMBER, SET_MULTIPLE_ITEM_CONDITION, SET_MULTIPLE_REMOVE_ITEM_CONDITION, SET_NAV_FROM_TO_SBI, SET_PAGES, SET_PARTY_FILTER_SORT_FILTER, SET_SEARCH_BY_IMAGE, SET_SEARCH_MODE, SET_SEARCH_TEXT, SET_SIMILAR_DATA, SET_SORT_GROUPITEM_DATA, SET_SORT_HEADING_GROUP, SET_TOP_SEARCH_COUNT, SET_TOTAL_CART_ITEMS, SET_VT_MID_LIST, SORT_FILTER, TEMPLATE_STATE } from "./ActionTypes";

const Reducer = (state, action) => {
    switch (action.type) {
        case SET_LOGIN:
            return {
                ...state,
                LoginInfo: action.payload,
                token: action.token,
            };
        case SET_CATALOGUE_DATA:
            return {
                ...state,
                catalogueData: action.catalogueData,
            };
        case SET_FILTER_DATA:
            return {
                ...state,
                filterData: action.filterData, 
            }

        case HANDLE_FILTERS_IS_CHECKED:
            const filterDataIndex = state.filterData?.findIndex((filter) => (filter.FILTER_DESC === action.filterID?.FILTER_DESC) && (filter.FILTER_HEADING === action.filterID?.FILTER_HEADING));
            // if(action.filterID.FILTER_HEADING === 'DATE RANGE') {
            //     state.filterData[filterDataIndex].INPUT_MIN_VALUE = '';
            //     state.filterData[filterDataIndex].INPUT_MAX_VALUE = '';
            // }
            return {
                ...state,
                filterData: [...state.filterData?.slice(0, filterDataIndex),
                    Object.assign({}, state.filterData[filterDataIndex], {"IS_CHECKED": state.filterData[filterDataIndex]?.IS_CHECKED === "0" ? "1" : "0"}),
                    ...state.filterData?.slice(filterDataIndex+1)
                ]
            }
        case HANDLE_SELECT_ALL_FILTERS: {
            return {
                ...state,
                filterData: state.filterData?.map((filterItems) => {
                    if (filterItems.FILTER_HEADING === action.payload) {
                        return ({
                            ...filterItems,
                            "IS_CHECKED": "1"
                        })
                    } else {
                        return ({
                            ...filterItems
                        })
                    }
                })
            }
        }

        case HANDLE_DATE_FILTERS :
            const allDateRangeIndex = state.filterData?.reduce((r, v, i) => r.concat(v.FILTER_HEADING === 'AGE' ? i : []), []);
            // const filterDateIndex = state.filterData?.findIndex((filter) => filter.FILTER_ID === action.filterID);
            const dateFilterData = state.filterData?.splice(allDateRangeIndex?.[0], allDateRangeIndex?.length).map((dateFilter) => {
                if(dateFilter?.FILTER_DESC === action.filterDesc) {
                  return {...dateFilter, "IS_CHECKED" : "1"}
                }
                else {
                  return {...dateFilter, "IS_CHECKED": "0"}
                }
              })
            return {
                ...state,
                filterData: [...state.filterData?.slice(0, allDateRangeIndex[0]),
                    ...dateFilterData,
                    ...state.filterData?.slice(allDateRangeIndex[0])
                ]
            }
            /*
                [...state.filterData?.slice(0, allDateRangeIndex[0]),
                    Object.assign({}, state.filterData[allDateRangeIndex[0]], {"IS_CHECKED": allDateRangeIndex[0] == filterDateIndex ? "1" : "0"}),
                    Object.assign({}, state.filterData[allDateRangeIndex[1]], {"IS_CHECKED": allDateRangeIndex[1] == filterDateIndex ? "1" : "0"}),
                    Object.assign({}, state.filterData[allDateRangeIndex[2]], {"IS_CHECKED": allDateRangeIndex[2] == filterDateIndex ? "1" : "0"}),
                    ...state.filterData?.slice(allDateRangeIndex[allDateRangeIndex?.length-1]+1)
                ]
            */
        case SET_ITEMS_DATA:
            return {
                ...state,
                items: action.items, 
            }
        case SET_ITEM_IS_SELECTED:
            const itemIndex = state.items?.findIndex((item) => item.CATALOG_ITEM_ID === action.itemID);
            return {
                ...state,
                items: [...state.items?.slice(0, itemIndex),
                    Object.assign({}, state.items[itemIndex], {"IS_SELECTED": "1"}),
                    ...state.items?.slice(itemIndex+1)
                ]
            }
        case SET_ITEM_IS_NOT_SELECTED:
            const index = state.items?.findIndex((item) => item.CATALOG_ITEM_ID === action.itemID);
            return {
                ...state,
                items: [...state.items?.slice(0, index),
                    Object.assign({}, state.items[index], {"IS_SELECTED": "0"}),
                    ...state.items?.slice(index+1)
                ]
            }
        case SET_MULTIPLE_ITEM_CONDITION: 
            let tempItemsData = state.items?.map((itemValue) => {
                if(action.addCartItems?.findIndex((multipleItem) => multipleItem.CATALOG_ITEM_ID === itemValue?.CATALOG_ITEM_ID) !== -1 && 
                    action.addCartItems?.findIndex((multipleItem) => multipleItem?.['SET NO'] === itemValue?.['SET NO']) !== -1) {
                    return ({...itemValue, "IS_SELECTED": '1'})
                }
                else {
                    return ({...itemValue})
                }
            })
            return {
                ...state,
                items: tempItemsData
            }
        case SET_MULTIPLE_REMOVE_ITEM_CONDITION: 
            let tempItemsDataVal = state.items?.map((itemValue) => {
                if(action.removeCart?.findIndex((multipleItem) => multipleItem.CATALOG_ITEM_ID === itemValue?.CATALOG_ITEM_ID) !== -1 && 
                    action.removeCart?.findIndex((multipleItem) => multipleItem?.['SET NO'] === itemValue?.['SET NO']) !== -1)  {
                    return ({...itemValue, "IS_SELECTED": '0'})
                }
                else {
                    return ({...itemValue})
                }
            })
            return {
                ...state,
                items: tempItemsDataVal
            }
        case SET_ITEM_PK_ID:
            const itemIndexPkId = state.items?.findIndex((item) => item.CATALOG_ITEM_ID === action.itemAddId);
            return {
                ...state,
                items: [...state.items?.slice(0, itemIndexPkId),
                    Object.assign({}, state.items[itemIndexPkId], {"PK_ID": action.itemPKId}),
                    ...state.items?.slice(itemIndexPkId+1)
                ]
            }
        case SET_LOADING:
            return {
                ...state,
                loading: action.loading, 
            }
        case SET_HAS_MORE:
            return {
                ...state,
                hasMore: action.hasMore, 
            }
        case SET_PAGES:
            return {
                ...state,
                pages: action.pages, 
            }
        case INCREMENT_PAGES:
            return {
                ...state,
                pages: state.pages + 1, 
            }
        case SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.errorMessage,
            }
        case SET_ADD_CART : 
            return {
                ...state,
                cart: action.cart
            }
        case INCREMENT_CART_QUANTITY:
            const cartIncrementIndex = state.cart?.findIndex((cartItem) => cartItem.PK_ID === action.cartPK_ID);
            return {
                ...state,
                cart: [...state.cart?.slice(0, cartIncrementIndex),
                    Object.assign({}, state.cart[cartIncrementIndex], {"QUANTITY": (Number(state.cart[cartIncrementIndex].QUANTITY) + 1).toString()}),
                    ...state.cart?.slice(cartIncrementIndex+1)
                ]
            }
        case DECREMENT_CART_QUANTITY:
            const cartDecrementIndex = state.cart?.findIndex((item) => item.PK_ID === action.cartPK_ID);
            return {
                ...state,
                cart: [...state.cart?.slice(0, cartDecrementIndex),
                    Object.assign({}, state.cart[cartDecrementIndex], {"QUANTITY": (Number(state.cart[cartDecrementIndex].QUANTITY) - 1).toString()}),
                    ...state.cart?.slice(cartDecrementIndex+1)
                ]
            }
        case SET_ACTIVE_CATALOGUE_ID :
            return {
                ...state,
                activeCatalogueId: action.activeCatalogueId
            }
        case REMOVE_CART:
            const filterCartData = state.cart?.filter((cartData) => cartData?.PK_ID !== action.cartPK_ID)
            return {
                ...state,
                cart: filterCartData
            }
        case SEARCH_ITEM_DATA:
            return {
                ...state,
                searchItem: action.searchItem,
            }
        case SET_GUID:
            return {
                ...state,
                guid: action.guid
            }
        case SET_SEARCH_TEXT: 
            return {
                ...state,
                searchText: action.searchText
            }
        case SET_DRAWER:
            return {
                ...state,
                drawerShow: action.drawerShow
            }
        
        case SET_CATALOGUE_STATUS:
            return {
                ...state,
                catalogueStatus: action.catalogueStatus
            }                    
        case SET_FILTER_TAB_OPTION: 
            return {
                ...state,
                defaultActiveSidebar: action.selectedData
            }
        case ENABLE_CATALOGUE_DRAWER: 
            return {
                ...state,
                catalogueDrawer: action.catalogueDrawer
            }
        case DISABLE_CATALOGUE_DRAWER: 
            return {
                ...state,
                catalogueDrawer: action.catalogueDrawer
            }
        case SET_ITEM_EDIT_IS_SELECTED:
            const editIndex = state.items?.findIndex((item) => item.CATALOG_ITEM_ID === action.itemID);
            return {
                ...state,
                items: [...state.items?.slice(0, editIndex),
                    Object.assign({}, state.items[editIndex], {"EDIT": "1"}),
                    ...state.items?.slice(editIndex+1)
                ]
            }
        case SET_ITEM_EDIT_NOT_SELECTED:
            const editItemIndex = state.items?.findIndex((item) => item.CATALOG_ITEM_ID === action.itemID);
            return {
                ...state,
                items: [...state.items?.slice(0, editItemIndex),
                    Object.assign({}, state.items[editItemIndex], {"EDIT": "0"}),
                    ...state.items?.slice(editItemIndex+1)
                ]
            }
        case SCROLL_POSITION_FINDER:
            return {
                ...state,
                lastScrollPosition: action.lastScrollPosition
            }
        
        case SET_TOTAL_CART_ITEMS:
            return {
                ...state,
                totalCartItem: action.totalCartItem
            }
        
        case SET_CUSTOM_CATALOGUE:
            return {
                ...state,
                customCatalogue: action.customCatalogue
            }
        case SET_MOBILE_NUMBER:
            return {
                ...state,
                mobileNumber: action.mobileNumber
            }

        case CLEAR_SEARCH_TEXT: 
            return {
                ...state,
                clearSearchText: action.clearSearchText
            }
        case GROUP_PARTY_LOADING: 
            return {
                ...state,
                groupPartyLoading: action.groupPartyLoading
            }
        case GROUP_PARTY_DATA: 
            return {
                ...state,
                groupPartyList: action.groupPartyList
            }
        case GROUP_PARTY_FILTER_HEADING: {
            return {
                ...state,
                groupPartyFilterHeading: action.groupPartyFilterHeading
            }
        } 
        case PARTY_FILTER_STATE: {
            return {
                ...state,
                partyFilterState: action.partyFilterState
            }
        } 
        case TEMPLATE_STATE: {
            return {
                ...state,
                template: action.template
            }
        }
        case SORT_FILTER: {
            return {
                ...state,
                sortFilterData: action.sortFilterData
            }
        }
        case SET_PARTY_FILTER_SORT_FILTER: {
            return {
                ...state,
                sortPartyList: action.sortPartyList
            }
        }
        
        case SET_SEARCH_MODE : {
            return {
                ...state,
                searchMode: action.searchMode
            }
        }
        case SET_ALL_ITEMS : {
            return {
                ...state,
                allItemsData: action.allItemsData
            }
        }
        case SET_SIMILAR_DATA : {
            return {
                ...state,
                similarSearchUrl: action.similarSearchUrl,
                similarItemData: action.similarItemData,
                similarItemAgg:action.similarItemAgg,
            }
        }
        case SET_SORT_GROUPITEM_DATA: {
            return {
                ...state,
                sortFilterOfGroupItem: action.sortFilterOfGroupItem
            }
        }
        case SET_SORT_HEADING_GROUP: {
            return {
                ...state, 
                sortFilterOfGroupItemHeading: action.sortFilterOfGroupItemHeading
            }
        }
        case CLEAR_SORT_FILTERS_OF_GROUP: {
            return {
                ...state,
                clearSortFilter: action.clearSortFilter
            }
        }
        case ALL_GROUP_OPTION_LISTS:
            return {
                ...state,
                allGroupOptionLists: action.allGroupOptionLists
            }
        case SET_HEADER_DOCUMENT_LIST:
            return{
                ...state,
                documentList : action.payload,
                quotationToken: action.quotationToken
            }
        case SET_SEARCH_BY_IMAGE:
            return{
                ...state,
                searchByImage : action.searchByImage,
                ...(action.searchByImageData !== undefined ? { searchByImageData: action.searchByImageData } : {}),
            }
        case SET_CLIENT_NAME:
            return{
                ...state,
                client_name : action.client_name,
            }
        case SET_TOP_SEARCH_COUNT:
            return{
                ...state,
                top_search_count : action.top_search_count,
            }
        case SET_NAV_FROM_TO_SBI:
            return{
                ...state,
                nav_from_to_sbi : action.nav_from_to_sbi,
            }
        case SET_VT_MID_LIST:
            return{
                ...state,
                vt_mid_list : action.vt_mid_list,
            }
        case SET_LOGOUT: 
            return {
                LoginInfo: {SESSION_ID: '',LOGIN_NAME: "", PARTY_ID: '', LOCATION_ID: '', PARTY_NAME: '', COMPANY_ID: '', IMAGE_FOLDER_URL: ''},
                token: '',
                catalogueData: null, 
                filterData: null, 
                items: [], 
                loading: false, 
                hasMore: true, 
                pages: 1,
                errorMessage: null,
                cart: [],
                activeCatalogueId: 0,
                searchText: '',
                guid: '',
                drawerShow: false,
                defaultActiveSidebar: '',
                customCatalogue: null,
                totalCartItem: 0,
                clearSearchText: null,
                groupPartyLoading : false,
                groupPartyList : [],
                groupPartyFilterHeading: null,
                lastScrollPosition: null, 
                partyFilterState: null,
                template: 'DEFAULT',
                searchMode: 'SET',
                sortFilterOfGroupItem: null,
                sortFilterOfGroupItemHeading: null,
                clearSortFilter: 'no',
                allGroupOptionLists: null,
                searchByImage:false
            }
        default:
            return state;
    }
};

export default Reducer;


// const tempFilter = state.filterData?.map((filterDate) => {
//     if(filterDate.FILTER_HEADING === 'DATE RANGE') {
//         if( filterDate.FILTER_ID === action.filterID) {
//             return {...filterDate, "IS_CHECKED": "1"}
//         }
//         else{
//             return {...filterDate, "IS_CHECKED": "0"}
//         }
//     }
//     else{
//         return filterDate
//     }
// })
// case SET_CART_REMARKS:
//     const remarkIndex = state.cart?.findIndex((item) => item.PK_ID === action.cartID?.PkId);
//     return {
//         ...state,
//         cart: [...state.cart?.slice(0, remarkIndex),
//             Object.assign({}, state.cart[remarkIndex], {"REMARKS": action.cartID?.remark}),
//             ...state.cart?.slice(remarkIndex+1)
//         ]
//     }
// SET_CART_REMARKS,